<template>
  <div class="container food-list">
    <h3 class="text-center">Food List</h3>
    <FoodTable @getDetailFood="getDetailFood" @toEdit="toEdit" ><FoodTable/>
  </div>
</template>

<script>
import axios from "../apis/server";
import FoodTable from "../components/foodTable.vue";
export default {
  name: "Foodlist",
  methods:{
    getDetailFood(getDetailFood){
      this.$emit('getDetailFood', getDetailFood)
    },
    toEdit(food){
      this.$emit('toEdit', food)
    }
  },
  data(){
    return{
      userData: ''
    }
  }
  ,
  components: {
    FoodTable,
  }
};
</script>

<style>
</style>